module.exports = __webpack_public_path__ + "img/zw.e56750e0.svg";